import { render, staticRenderFns } from "./FeedbackFormModal.vue?vue&type=template&id=0d578d70&scoped=true"
import script from "./FeedbackFormModal.vue?vue&type=script&lang=js"
export * from "./FeedbackFormModal.vue?vue&type=script&lang=js"
import style0 from "./FeedbackFormModal.vue?vue&type=style&index=0&id=0d578d70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d578d70",
  null
  
)

export default component.exports